import LineBedDoubleIcon from 'components/Luxkit/Icons/line/LineBedDoubleIcon'
import LineClockWithTickIcon from 'components/Luxkit/Icons/line/LineClockWithTickIcon'
import LineCommentAltIcon from 'components/Luxkit/Icons/line/LineCommentAltIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'

function VillasWhyBookWithUs() {
  return (
    <Group direction="vertical" gap={32}>
      <Heading variant="heading2" colour="neutral-one">
        Why you should book with us
      </Heading>
      <Group
        gap={24}
        direction="vertical"
        tabletDirection="horizontal"
        horizontalAlign="start"
        tabletHorizontalAlign="space-between"
      >
        <Group direction="vertical" gap={12}>
          <LineBedDoubleIcon size="L" colour="neutral-one" />
          <Group direction="vertical" gap={4}>
            <BodyText colour="neutral-one" variant="medium" weight="bold">
              Thousands of handpicked villa stays
            </BodyText>
            <BodyText variant="medium" colour="neutral-one">
              Unlock a world of premium villa options, handpicked just for you.
            </BodyText>
          </Group>
        </Group>
        <Group direction="vertical" gap={12}>
          <LineClockWithTickIcon size="L" colour="neutral-one" />
          <Group direction="vertical" gap={4}>
            <BodyText variant="medium" weight="bold" colour="neutral-one">
              Instant booking confirmation
            </BodyText>
            <BodyText variant="medium" colour="neutral-one">
              Real-time availability for immediate booking confirmation
            </BodyText>
          </Group>
        </Group>
        <Group direction="vertical" gap={12}>
          <LineCommentAltIcon size="L" colour="neutral-one" />
          <Group direction="vertical" gap={4}>
            <BodyText variant="medium" weight="bold" colour="neutral-one">
              24/7 customer service
            </BodyText>
            <BodyText variant="medium" colour="neutral-one">
              Round-the-clock support from our dedicated team
            </BodyText>
          </Group>
        </Group>
      </Group>
    </Group>
  )
}

export default VillasWhyBookWithUs
